/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_contact_fields_request_subject = /** @type {(inputs: {}) => string} */ () => {
	return `Předmět žádosti`
};

const da_contact_fields_request_subject = /** @type {(inputs: {}) => string} */ () => {
	return `Emne for henvendelsen`
};

const de_contact_fields_request_subject = /** @type {(inputs: {}) => string} */ () => {
	return `Betreff der Anfrage`
};

const en_contact_fields_request_subject = /** @type {(inputs: {}) => string} */ () => {
	return `Request subject`
};

const es_contact_fields_request_subject = /** @type {(inputs: {}) => string} */ () => {
	return `Asunto de la consulta`
};

const fr_contact_fields_request_subject = /** @type {(inputs: {}) => string} */ () => {
	return `Objet de la demande`
};

const hu_contact_fields_request_subject = /** @type {(inputs: {}) => string} */ () => {
	return `Kérelem tárgya`
};

const it_contact_fields_request_subject = /** @type {(inputs: {}) => string} */ () => {
	return `Oggetto della richiesta`
};

const nl_contact_fields_request_subject = /** @type {(inputs: {}) => string} */ () => {
	return `Onderwerp van de aanvraag`
};

const pl_contact_fields_request_subject = /** @type {(inputs: {}) => string} */ () => {
	return `Temat zapytania`
};

const pt_contact_fields_request_subject = /** @type {(inputs: {}) => string} */ () => {
	return `Assunto do pedido`
};

const sv_contact_fields_request_subject = /** @type {(inputs: {}) => string} */ () => {
	return `Ärendets ämne`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const contact_fields_request_subject = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_fields_request_subject(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("contact_fields_request_subject", locale)
	if (locale === "cs") return cs_contact_fields_request_subject(inputs)
	if (locale === "da") return da_contact_fields_request_subject(inputs)
	if (locale === "de") return de_contact_fields_request_subject(inputs)
	if (locale === "en") return en_contact_fields_request_subject(inputs)
	if (locale === "es") return es_contact_fields_request_subject(inputs)
	if (locale === "fr") return fr_contact_fields_request_subject(inputs)
	if (locale === "hu") return hu_contact_fields_request_subject(inputs)
	if (locale === "it") return it_contact_fields_request_subject(inputs)
	if (locale === "nl") return nl_contact_fields_request_subject(inputs)
	if (locale === "pl") return pl_contact_fields_request_subject(inputs)
	if (locale === "pt") return pt_contact_fields_request_subject(inputs)
	return sv_contact_fields_request_subject(inputs)
};
export { contact_fields_request_subject as "contact.fields.request_subject" }